import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from 'react-dropdown-select';
import { ExportExcel, getMenuPermissions, GetOutletList } from "../../Services/FXAPIServices";
import { OutletInterface, RangeSelection } from "../../assets/interfaces/FX_POS_Interfaces";
import { useDispatch, useSelector } from "react-redux";
import { storeAppIntegrations, storeMenuList, storeOutlets, storeSelectedAction, storeSelectedOutlet } from "../../Redux/action";
import { useNavigate } from "react-router-dom";
import FXDateRangePicker from "./FXDateRangePicker";
import { useMenu } from "../../context/MenuContext";
import { QUICK_ACTIONS_BY_MENU } from "./QuickActions";
import { GetListCommonCall } from "../../POS/APIServices/POS_API_Services";
import HelperService from "../../Services/HelperService";
import ReactDropdownSelect from "react-dropdown-select";
import { useFeaturePermission } from "../../FeaturePermissions/FeaturePermissionContext";

const optionsReport = [
  { label: 'Sales Report', value: 'master/sales-report' },
  { label: 'Customer Report', value: 'master/customer-report' },
  { label: 'Wastage Report', value: 'master/wastage-report' },
  { label: 'Purchase Inventory Report', value: 'master/inventory-purchase-report' },
  { label: 'Staff Operation Report', value: 'master/staff-operation-report' },
  { label: 'Finance Report', value: 'master/finance-report' },
];
interface PropsData {
  handleOutletSelection?: (params: string, type: string) => void;
  rangeSelection?: RangeSelection;
  isHideDateRange?: boolean;
  isHideOutlet?: boolean;
  setRangeSelection?: (value: RangeSelection) => void;

}
const CompoPageFilter = ({
  handleOutletSelection, rangeSelection, setRangeSelection, isHideDateRange = false, isHideOutlet = false
}: PropsData) => {
  const { loadFeatures } = useFeaturePermission();
  let navigate = useNavigate();
  const selectedActions = useSelector((state: any) => state?.items?.storedAction);
  const [selectedAction, setSelectedAction] = useState<{ label: string; value: string }[]>(selectedActions);
  const [selectedReport, setSelectedReport] = useState<{ label: string; value: string }[]>([]);
  const dispatch = useDispatch();
  const selectedOutlets = useSelector((state: any) => state?.items?.storeSelectedOutlet);
  const [outletList, setOutletList] = useState<OutletInterface[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [storedSelectedOutlet, setStoredSelectedOutlet] = useState<OutletInterface[]>(selectedOutlets);
  const [selectedOutlet, setSelectedOutlet] = useState<OutletInterface[]>(storedSelectedOutlet || []);
  const { selectedMenuKey } = useMenu();
  const quickActions = QUICK_ACTIONS_BY_MENU[selectedMenuKey] || [];
  const [quickActionsList, setQuickActionsList] = useState<{ label: string; value: string, stateKey?: string, stateValue?: string }[]>(quickActions);
  useEffect(() => {
    setLoading(true);
    GetOutletList()
      .then((list: any) => {
        dispatch(storeOutlets([]));
        // dispatch(storeSelectedOutlet([]))
        if (list?.length > 0) {
          setOutletList(list);
          localStorage.setItem('outlet_id', selectedOutlet[0].id);
          // setSelectedOutlet([list[0]]);
          // dispatch(storeSelectedOutlet([list[0]]))
          dispatch(storeOutlets(list));
        }
        setLoading(false);
      }).catch(() => { })
      .finally(() => {
        setLoading(false);
      });
    setQuickActionsList(quickActions);
    getPermissions();
    getMenus();
  }, []);

  const onChangeAction = (value: any) => {
    setSelectedAction(value);
    const stateKey = value[0]?.stateKey;
    const stateValue = value[0]?.stateValue;
    dispatch(storeSelectedAction(value));
    navigate(value[0]?.value, { state: { [stateKey]: stateValue } });
  }

  const onDateRangeSelection = (value: any) => {
    setRangeSelection && setRangeSelection(value);
    handleOutletSelection && handleOutletSelection(value, 'RANGE');
  }
  const onChangeReport = (value: any) => {
    setSelectedReport(value);
    let params: any = {
      fromDate: HelperService.getAPIFormatedDate(rangeSelection?.startDate),
      toDate: HelperService.getAPIFormatedDate(rangeSelection?.endDate),
      exportType: 'EXCEL',
    }
    if (value[0]?.value === 'master/sales-report') {
      params = {
        ...params,
        reportType: 'DETAILED',//SUMMARY
      }
    }
    ExportExcel(value[0]?.value, HelperService.toQueryString(params), [], "export-button", value[0]?.label);
  }
  const handleOutletChange = (value: any) => {
    setSelectedOutlet(value);
    dispatch(storeSelectedOutlet(value));
    localStorage.setItem('outlet_id', value[0]?.id);
    handleOutletSelection && handleOutletSelection(value[0]?.id, 'OUTLET');
    getPermissions();
    getMenus();
  }

  const getPermissions = () => {
    getMenuPermissions().then((res: any) => {
      loadFeatures(res?.data || []);
      return res?.data;
    }).catch((error: any) => {
    });
  }
  const getMenus = () => {
    GetListCommonCall("staffs/my-menus?timestamp=" + new Date().toISOString(), {}, 'login-button')
      .then((res: any) => {
        if (res?.data?.length > 0) {
          dispatch(storeMenuList(res.data || []))
          dispatch(storeAppIntegrations(res.appIntegrations || []))
        } else {
          dispatch(storeMenuList([]))
          dispatch(storeAppIntegrations([]))
        }
      })
  }
  return (
    <>
      <Row className="g-3 mb-3">
        {!isHideOutlet &&
          <Col lg={3} md={6} xs={12}>
            <Select
              options={outletList}
              values={selectedOutlet}
              valueField="id"
              loading={isLoading}
              searchBy="outlet_name"
              searchable
              labelField="outlet_name"
              onChange={(value: any) => {
                handleOutletChange(value)
              }}
              placeholder="Select Outlet"
            />
          </Col>
        }
        {!isHideDateRange &&
          <Col lg={3} md={6} xs={12}>
            <FXDateRangePicker date_range={rangeSelection} selectData={onDateRangeSelection} />
          </Col>
        }

        <Col lg={3} md={6} xs={12}>
          <Select
            options={quickActionsList}
            searchBy="label"
            valueField="label"
            labelField="label"
            clearable={selectedAction?.length > 0}
            searchable
            sortBy="label"
            values={selectedAction}
            onChange={(action: any) => {
              console.log(action);
              if (action.length === 0) {
                setSelectedAction([]);
                dispatch(storeSelectedAction([]));
              } else {
                onChangeAction(action)
              }
            }
            }
            placeholder="Quick Action"
          />
        </Col>
        <Col lg={3} md={6} xs={12}>

          {/* <Form.Select
            aria-label="Default select example"
            onChange={(e: any) => {
              onChangeReport(e.target.value)
            }}
          >
            <option value="">Select Report</option>
            {optionsReport?.map((item: any) => (
              <option key={item?.value} value={item?.value}>{item?.label}</option>
            ))}
          </Form.Select> */}

          {/* <ReactDropdownSelect
            options={optionsReport}
            placeholder="Reports"
            className="w-100"
            labelField="label"
            searchBy="label"
            sortBy="label"
            valueField="value"
            closeOnSelect={false}
            values={selectedReport}
            onChange={(value: any) => {
              setSelectedReport(value);
              onChangeReport(value);
            }}
          /> */}

          <Button variant="outline-primary" className="w-100 text-wrap" onClick={() => {
            navigate('/restaurant-admin/finance-analysis');
          }}>Generate Reports</Button>
        </Col>
      </Row>
    </>
  );
}
export default CompoPageFilter;